const isPlainObject = (value: unknown): value is Record<string, unknown> =>
    value !== null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    !(value instanceof Date)

export const trimStringsDeep = <T>(value: T): T => {
    if (typeof value === 'string') return value.trim() as T

    if (Array.isArray(value))
        return value.map(item => trimStringsDeep(item)) as T

    if (!isPlainObject(value)) return value

    const trimmed: Record<string, unknown> = {}

    Object.keys(value).forEach(key => {
        trimmed[key] = trimStringsDeep(value[key])
    })

    return trimmed as T
}
